import decamelize from 'decamelize'
import camelcase from 'camelcase'
import { QueryParamsType } from './type'
import * as envType from '@/constants/envType'
import dayjs from 'dayjs'
import { isCordovaEnvironment, isPlatformWindows } from '@/utils/cordova'
import Vue from 'vue'
import store from '@/store'

export const filterQueryParams = (params: {
  [key: string]: string | number | boolean | null | undefined
}): QueryParamsType =>
  Object.keys(params).reduce((queryParams, key) => {
    return params[key] ? { ...queryParams, [key]: params[key] } : queryParams
  }, {})

type ParamsType = {
  [key: string]: string | number | boolean | null | undefined | ParamsType
}

export const decamelizeKeys = (params: ParamsType): ParamsType =>
  Object.keys(params).reduce(
    (decamelized, key) => ({
      ...decamelized,
      [decamelize(key)]:
        typeof params[key] === 'object' && params[key] !== null
          ? decamelizeKeys(params[key] as ParamsType)
          : params[key]
    }),
    {}
  )

export const camelizeKeys = (params: ParamsType): ParamsType =>
  Object.keys(params).reduce(
    (camelized, key) => ({
      ...camelized,
      [camelcase(key)]:
        typeof params[key] === 'object' && params[key] !== null
          ? camelizeKeys(params[key] as ParamsType)
          : params[key]
    }),
    {}
  )

export const separateNumberSuffix = (params: {
  [key: string]: any
}): { [key: string]: any } =>
  Object.keys(params).reduce((converted, key) => {
    const match = key.match(/([^\d]+)([\d]+)/)
    const newKey = Array.isArray(match) ? `${match[1]}_${match[2]}` : key
    converted[newKey] = params[key]
    return converted
  }, {} as { [key: string]: number })

export const getEnvVar = (name: string) => {
  const env = process.env

  switch (env.NODE_ENV) {
    case envType.DEVELOPMENT:
      return env[`VUE_APP_${envType.DEV_ABBR.toUpperCase()}_${name}`]

    case envType.STAGING:
      return env[`VUE_APP_${envType.STG_ABBR.toUpperCase()}_${name}`]

    case envType.PRODUCTION:
      return env[`VUE_APP_${envType.PROD_ABBR.toUpperCase()}_${name}`]

    default:
      return env[`VUE_APP_${envType.DEV_ABBR.toUpperCase()}_${name}`]
  }
}

export const isEnv = (envName: string) => process.env.NODE_ENV === envName

export const base64Encode = (...parts: BlobPart[]) => {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        const offset = reader.result.indexOf(',') + 1
        resolve(reader.result.slice(offset))
      }
    }
    reader.readAsDataURL(new Blob(parts))
  })
}

export const weekOfYear = (day: {
  year: number | string
  month: number | string
  date: number | string
}) => {
  const { year, month, date } = day
  const newyear = dayjs(`${year}-01-01`)
  const add = newyear.day()
  const d = dayjs(`${year}-${month}-${date}`)
  const week = Math.ceil((d.dayOfYear() + add) / 7)
  return week
}

export const reloadApp = async () => {
  if (isCordovaEnvironment()) {
    if (isPlatformWindows()) {
      store.dispatch('ble/terminateAll')
      window.location.reload()
    } else {
      Vue.$postMessage.reloadApp()
      window.location.reload() // 互換性維持のため
    }
  } else {
    window.location.reload()
  }
}

export const PostMessageOrigin = '*'
